import { CauseOfLoss, UseCase } from '../../../src';
import { ClaimRequest } from '../../domain/entities/ClaimRequest';
import { ClaimRequestRepository } from '../../domain/repositories/ClaimRequestRepository';

export class UpdateCauseOfLoss implements UseCase<ClaimRequest> {
    private claimRequestRepository: ClaimRequestRepository;

    constructor(claimRequestRepository: ClaimRequestRepository) {
        this.claimRequestRepository = claimRequestRepository;
    }

    async execute(claimRequestKey: string, causeOfLoss: CauseOfLoss): Promise<ClaimRequest> {
        return this.claimRequestRepository.updateCauseOfLoss(claimRequestKey, causeOfLoss);
    }
}
